import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetRezyme = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_GROUP_REPORT_GAMES
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetRezymeAction({
                    data: data.data,
                    count: data.count
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetRezyme as SetGetRezyme
}